import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  theadContainer: {
    display: "flex",
    width: "100%",
  },
  tableCell: (props) => ({
    border: "none",
    width: "100%",
    maxWidth: 400,
    [theme.breakpoints.up("sm")]: {
      width: `${Math.round(100 / props.sizeFilters)}% !important`,
    },
  }),
}));
